import { getUID } from '@redviking/argonaut-util/src/getUID';
import { UiFlowNodeInput } from '../../sockets/UiFlowNodeInput';
import type { UiNodeSpec } from './UiNodeSpec';

export const sliceUiNodeSpec: UiNodeSpec<'slice'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'input', 'output', 'start', 'end' ],
    }),
    cfg: () => ({ id: getUID(), kind: 'slice', disabled: false }),
    controls: () => ({}),
    inputs: nodeCfg => {
        const end: UiFlowNodeInput.Opts<'number'> = {
            control: {
                cfg: { kind: 'number', nullable: true },
                nodeCfg,
                nullable: true,
                value: (nodeCfg.socketDefaults?.inputs?.end as number) || null,
            },
            socket: 'number',
            label: 'End Index (optional)',
            index: 2,
        };
        const input: UiFlowNodeInput.Opts<'string'> = { socket: 'string', label: 'Input', index: 0 };
        const start: UiFlowNodeInput.Opts<'number'> = {
            control: {
                cfg: { kind: 'number', nullable: true },
                nodeCfg,
                nullable: true,
                value: (nodeCfg.socketDefaults?.inputs?.start as number) || 0,
            },
            socket: 'number',
            label: 'Start Index',
            index: 1,
        };
        return {
            end,
            input,
            start,
        };
    },
    kindLabel: 'Text Slice',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: () => true,
};
